<template>
    <div class="catalog">
        <div class="catalog__head">
            <div class="catalog__filter catalog__filter--flow">
                <div class="filter">
                    <div class="filter__inner filter__inner--history">
                        <div class="filter__item filter__item--history">
                            <div class="b-select b-select--lg">
                                <div class="b-select__label">Выберите лицевой счет:</div>
                                <select class="b-select__picker selectpicker" data-style-base="button" v-model="accountId" id="uaccount">
                                    <!--<option value="">Все лицевые счета</option>-->
                                    <option v-for="a in accounts" v-bind:value="a.PersonAccountId"><span class="declarer-add__select-left">{{a.AccountNumber}}</span>{{a.City}}, {{a.Address}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="filter__item filter__item--history">
                            <div class="b-select">
                                <div class="b-select__label">Приборы учета</div>
                                <select class="b-select__picker selectpicker" data-style-base="button" id="ppu" v-model="number">
                                    <option value="">Все приборы учета</option>
                                </select>
                            </div>
                        </div>
                        <!--
                        <div class="filter__item filter__item--history">
                            <div class="b-select">
                                <div class="b-select__label">Статус показаний</div>
                                <select class="b-select__picker selectpicker" data-style-base="button">
                                    <option value="">Все</option>
                                    <option value="">Переданы</option>
                                    <option value="">Приняты</option>
                                    <option value="">Не приняты</option>
                                    <option value="">Не приняты. Брак</option>
                                </select>
                            </div>
                        </div>
                        -->
                        <div class="filter__item filter__item--s">
                            <label class="txt-input">
                                <div class="txt-input__label">Период с:</div>
                                <div class="txt-input__input">
                                    <!--<input class="txt-input__field input js-period-picker" type="date" required id="dateFrom1">-->
                                    <date-picker date-format="MM yyyy" required @date-changed="onStartDateChanged" :isError="dateAlert" :minDate="minDate" :maxDate="maxDate"></date-picker>
                                    <div class="txt-input__icon fab-icon">
                                        <i class="icon icon--calendar"></i>
                                    </div>
                                </div>
                            </label>
                        </div>
                        <div class="filter__item filter__item--s">
                            <label class="txt-input">
                                <div class="txt-input__label">Период по:</div>
                                <div class="txt-input__input">
                                    <!--<input class="txt-input__field input js-period-picker" type="text" required id="dateTo">-->
                                    <date-picker date-format="MM yyyy" required @date-changed="onEndDateChanged" :isError="dateAlert" :minDate="minDate" :maxDate="maxDate"></date-picker>
                                    <div class="txt-input__icon fab-icon">
                                        <i class="icon icon--calendar"></i>
                                    </div>
                                </div>
                            </label>
                        </div>
                        <div class="filter__item filter__item--btns">
                            <div class="">
                                <a href="" class="button button--th-ctrl js-form-payment-1" @click="getData">
                                    <span class="button__text">Сформировать</span>
                                </a>
                            </div>
                            <div class="filter__item--toggles js-form-btns-toggle">
                                <a href="" class="history-document" download>

                                    <img src="/images/icons-doc/xls.svg" alt="">
                                </a>
                                <div id="dropSearch" class="search-sm search-sm--right">
                                    <div class="search-sm__drop-overlay" data-drop-toggle="dropSearch"></div>
                                    <a href="" class="search-sm__button button-icon button-icon--th-ctrl" data-drop-toggle="dropSearch" data-scroll-free><i class="icon icon--search"></i></a>
                                    <div class="search-sm__drop search-sm__drop--testimony block">
                                        <input type="text" class="search-sm__input input" placeholder="Введите параметры для поиска: Номер Лицевого счёта, адрес помещения, номер ПУ и т.д." v-model="search">
                                        <!-- Чтобы скрыть сообщение использовать класс is-hide на search-sm__status -->
                                        <div class="search-sm__status is-hide">
                                            <div class="search-sm__text">Результаты не найдены</div>
                                            <div class="search-sm__clear">
                                                <a href="" class="link link--underline">
                                                    <span class="link__text">Очистить</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <a class="testimony-list__view button-icon button-icon--th-ctrl" data-collapse-toggle><i class="icon icon--d-angle-down"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="filter-message"></div>
        </div>
        <div class="catalog__body">
            <div class="block-wrap" data-catalog-list style="display: none;">
                <div class="pay-history testimony-list" v-for="account in historydata">
                    <div class="testimony-list__item collapse-item">
                        <a :href="'#history_'+account.personAccountId" class="collapse-item__head collapse-item__head--history block link collapsed" data-toggle="collapse">
                            <div class="collapse-item__title">
                                {{account.city}}, {{account.address}}
                                <!--<span class="text-bold">кв. 227/а</span>-->

                            </div>

                            <div class="collapse-item__entity" style="margin-left:auto">
                                <span>ЛС</span> № {{account.accountNumber}} <span><!--1234567891011122324322--></span>
                            </div>

                            <div class="collapse-item__ctrl collapse-item__ctrl--bg fab-icon">
                                <i class="icon icon--angle-down"></i>
                            </div>
                        </a>

                        <div :id="'history_'+account.personAccountId" class="collapse-item__body accordion-body collapse" data-toggle-body>
                            <div v-for="ppu in account.regPoints">
                                <div class="testimony-table__info testimony-individual-info testimony-individual-info--history">
                                    <div class="testimony-individual-info__text-container">
                                        <div class="testimony-individual-info__item">

                                            <img src="/images/testimony/counter-blue.svg" class="testimony-individual-info__icon" alt="горячая вода" v-if="ppu.prodCode==13" />

                                            <img src="/images/testimony/counter.svg" class="testimony-individual-info__icon" alt="холодная вода" v-if="ppu.prodCode==9" />

                                            {{ppu.counterType}}
                                        </div>
                                        <div class="history-header__item testimony-label__row testimony-label__row--history testimony-label__row--history-center">№{{ppu.serialNum}}</div>
                                        <div class="history-header__item testimony-label__row testimony-label__row--history testimony-label__row--history-center">{{itemCaption(ppu)}}</div>
                                        <!--<div class="history-header__item testimony-label__row testimony-label__row--history testimony-label__row--history-center">{{ppu.prodCaption}}</div>-->

                                        <div class="history-header__item testimony-label__row testimony-label__row--history testimony-label__row--history">
                                            <span v-if="ppu.checkState==-1" class="status-error">
                                                Гос. проверка: {{ppu.dateNextGosPov}}
                                            </span>
                                            <span v-if="ppu.checkState==0" class="status-success">
                                                Гос. проверка: {{ppu.dateNextGosPov}}
                                            </span>
                                            <span v-if="ppu.checkState==1">
                                                Гос. проверка: {{ppu.dateNextGosPov}}
                                            </span>
                                        </div>
                                        <div class="history-header__item testimony-label__row testimony-label__row--history testimony-label__row--history-center">Место установки: {{ppu.location}}</div>
                                    </div>
                                </div>


                                <div v-if="ppu.isTwoScales==false" class="testimony-individual-info testimony-individual-info--history testimony-individual-info--history-hidden">
                                    <div class="testimony-label__list testimony-label__list--center">
                                        <div class="testimony-label__item testimony-label__item--history testimony-label__item--left">Дата показаний</div>
                                        <div class="testimony-label__item testimony-label__item--history-lg">Предыдущее показание<br /> (м3)</div>
                                        <div class="testimony-label__item testimony-label__item--history-md">Текущее показание<br /> (м3)</div>
                                        <div class="testimony-label__item testimony-label__item--history-md">Расход воды (м3)</div>
                                        <div class="testimony-label__item testimony-label__item--history-md">Источник показаний</div>
                                    </div>
                                </div>
                                <div v-if="ppu.isTwoScales==true" class="testimony-individual-info testimony-individual-info--history testimony-individual-info--history-hidden">
                                    <div class="testimony-label__list testimony-label__list--center">
                                        <div class="testimony-label__item testimony-label__item--history testimony-label__item--left">Дата показаний</div>
                                        <div class="testimony-label__item testimony-label__item--history-lg">Предыдущее показание<br /> (Гкал)</div>
                                        <div class="testimony-label__item testimony-label__item--history-md">Текущее показание<br /> (Гкал)</div>
                                        <div class="testimony-label__item testimony-label__item--history-md">Расход воды (Гкал)</div>
                                        <div class="testimony-label__item testimony-label__item--history-lg">Предыдущее показание<br /> (м3)</div>
                                        <div class="testimony-label__item testimony-label__item--history-md">Текущее показание<br /> (м3)</div>
                                        <div class="testimony-label__item testimony-label__item--history-md">Расход воды (м3)</div>
                                        <div class="testimony-label__item testimony-label__item--history-md">Источник показаний</div>
                                    </div>
                                </div>

                                <div v-if="ppu.isTwoScales==false" class="testimony-table__row testimony-table__row--history block history-table--desctop" v-for="hd in ppu.history">
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-left">
                                        <div class="testimony-table__label">Дата показаний</div>
                                        {{hd.dateC}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-lg">
                                        <div class="testimony-table__label">Предыдущее показание (м3)</div>
                                        {{hd.ipuStats}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-md">
                                        <div class="testimony-table__label">Текущее показание (м3)</div>
                                        {{hd.ipuState}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-md">
                                        <div class="testimony-table__label">Расход воды (м3)</div>
                                        {{hd.rashod}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-md">
                                        <div class="testimony-table__label">Источник показаний</div>
                                        {{hd.indicationMethod}}
                                    </div>
                                </div>

                                <div v-if="ppu.isTwoScales==true" class="testimony-table__row testimony-table__row--history block history-table--desctop" v-for="hd in ppu.history">
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-left">
                                        <div class="testimony-table__label">Дата показаний</div>
                                        {{hd.dateC}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-lg">
                                        <div class="testimony-table__label">Предыдущее показание ({{hd.unit}})</div>
                                        {{hd.ipuStats}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-md">
                                        <div class="testimony-table__label">Текущее показание ({{hd.unit}})</div>
                                        {{hd.ipuState}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-md">
                                        <div class="testimony-table__label">Расход воды ({{hd.unit}})</div>
                                        {{hd.rashod}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-lg">
                                        <div class="testimony-table__label">Предыдущее показание ({{hd.unit2}})</div>
                                        {{hd.ipuStats2}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-md">
                                        <div class="testimony-table__label">Текущее показание ({{hd.unit2}})</div>
                                        {{hd.ipuState2}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-md">
                                        <div class="testimony-table__label">Расход воды ({{hd.unit2}})</div>
                                        {{hd.rashod2}}
                                    </div>
                                    <div class="testimony-table__cell testimony-table__cell--history testimony-table__cell--history-md">
                                        <div class="testimony-table__label">Источник показаний</div>
                                        {{hd.indicationMethod}}
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    function yyyymmdd(d, s) {
        var mm = d.getMonth() + 1; // getMonth() is zero-based
        var dd = d.getDate();
        return [d.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join(s);
    };

    function strToIsoDate(strDate) {
        return strDate.substr(6, 4) + '-' + strDate.substr(3, 2) + '-' + strDate.substr(0, 2);
    };

    function insensitive_search(str1, str2) {
        let search_str = new RegExp(str2, "ig");
        var result = str1.search(search_str);
        return (result >= 0);
    }

    import DatePicker from '../../../Components/DatePicker.vue';

    export default {
        name: 'ppu-history',
        components: {
            DatePicker
        },
        props: {
            accounts: Array
        },
        data() {
            return {
                accountId: '',
                number: '',
                state: '',
                dateFrom: null,
                dateTo: null,
                dateAlert: false,
                DateFrom: null,
                DateTo: null,
                historydata: null,
                historyRawData: null,
                search: '',
                startValue: undefined,
                maxDate: undefined,
                minDate: undefined
            }
        },
        watch: {
            accountId() {
                this.refreshPpu();
                this.setMinDate();
            },
            number() {
                this.setMinDate();
            },
            search() {
                if (this.search.length == 0) {
                    this.historydata = this.historyRawData;
                }
                if (this.search.length >= 4) {
                    this.historydata = this.searchFrom();
                }
            },
        },
        methods: {
            itemCaption: function (ppu) {
                var test = new Map();
                test.set(11, 'Отопление');
                test.set(10, 'Горячая вода');
                test.set(22, 'Отопление бани');
                test.set(25, 'Потери теплоэнергии');
                test.set(23, 'Отопление гаража');
                test.set(24, 'Отопление хоз.построек');
                test.set(27, 'Отопление летняя кухня');
                test.set(29, 'Отопление подвал');
                test.set(201, 'Отопление теплица');
                test.set(202, 'Отопление бассейн');
                test.set(1015, 'Фиктивное отопление');
                test.set(30, 'Отопление машино-место');
                test.set(21, 'Отопление ипу');
                test.set(15, 'Подпиточная вода');
                test.set(20, 'Утечки');
                test.set(28, 'Холодная вода');
                test.set(911, 'Горячее водоснабжение баня');
                test.set(912, 'Горячее водоснабжение гараж');
                test.set(913, 'Горячее водоснабжение летняя кухня');
                test.set(914, 'Горячее водоснабжение хоз.постройки');
                test.set(915, 'Горячее водоснабжение бассейн');
                test.set(916, 'Горячее водоснабжение полив');
                test.set(917, 'Горячее водоснабжение теплица');
                test.set(93, 'ХВС на ГВС(ниже 40)');
                test.set(91, 'Горячая вода');
                test.set(95, 'ГВС: тепловая энергия');
                test.set(98, 'Холодная вода для ГВС');
                test.set(134, 'Полив');
                test.set(135, 'Баня');
                test.set(137, 'ХВС на ГВС(ниже  40)');
                test.set(131, 'Холодная вода');
                test.set(133, 'Холодная вода для ГВС');

                return test.get(ppu.item);

            },

            setMinDate() {
                this.minDate = new window.Date();
                console.info("setMinDate start", this.minDate);
                if (this.accountId != '') {
                    for (var i = 0; i < this.accounts.length; i++) {
                        if (this.accounts[i].PersonAccountId == this.accountId) {
                            this.minDate = this.parseDate(this.accounts[i].BeginDate);
                        }
                    }
                }
                console.info("setMinDate end", this.minDate);
            },
            parseDate(strDate) {
                console.info("parseDate ", strDate);
                return new window.Date(strToIsoDate(strDate));
                return new window.Date(strDate);
                return new window.Date();
            },
            uaccount() {
                return $("#uaccount").val();
            },
            unumber() {
                return $("#ppu").val();
            },

            //определяет -есть ли вторая шкала у счетчика
            isTwoScales(device) {
                var result = false;
                if (device.unit2 != undefined && device.unit2 != null && device.unit2 != "") { if (device.unit2.length > 0) result = true; }
                return result;
            },

            searchFrom() {

                function foundInResult(searchResult, personAccountId) {
                    if (searchResult.filter(el => el.personAccountId !== personAccountId) != undefined) {
                        return true;
                    }
                    return false;
                }

                var searchResult = [];

                //Номер Лицевого счёта
                for (var i = 0; i < this.historyRawData.length; i++) {
                    if (this.historyRawData[i].accountNumber.includes(this.search)
                        && foundInResult(searchResult, this.historyRawData[i].personAccountId)) {
                        searchResult.push(this.historyRawData[i]);
                    }
                }
                //Город
                for (var i = 0; i < this.historyRawData.length; i++) {
                    if (insensitive_search(this.historyRawData[i].city, this.search)
                        && foundInResult(searchResult, this.historyRawData[i].personAccountId)) {
                        searchResult.push(this.historyRawData[i]);
                    }
                }
                //улица, № домовладения
                for (var i = 0; i < this.historyRawData.length; i++) {
                    if (insensitive_search(this.historyRawData[i].address, this.search)
                        && foundInResult(searchResult, this.historyRawData[i].personAccountId)) {
                        searchResult.push(this.historyRawData[i]);
                    }
                }
                //Наименование ПУ
                for (var i = 0; i < this.historyRawData.length; i++) {
                    for (var j = 0; j < this.historyRawData[i].regPoints.length; j++) {
                        //console.log(this.historyRawData[i].regPoints[j]);
                        if (insensitive_search(this.historyRawData[i].regPoints[j].counterType, this.search)
                            && foundInResult(searchResult, this.historyRawData[i].personAccountId)) {
                            searchResult.push(this.historyRawData[i]);
                        }
                    }
                }
                //Серийный номер ПУ
                for (var i = 0; i < this.historyRawData.length; i++) {
                    for (var j = 0; j < this.historyRawData[i].regPoints.length; j++) {
                        if (insensitive_search(this.historyRawData[i].regPoints[j].serialNum, this.search)
                            && foundInResult(searchResult, this.historyRawData[i].personAccountId)) {
                            searchResult.push(this.historyRawData[i]);
                        }
                    }
                }
                //Дата окончания поверки ПУ
                for (var i = 0; i < this.historyRawData.length; i++) {
                    for (var j = 0; j < this.historyRawData[i].regPoints.length; j++) {
                        if (insensitive_search(this.historyRawData[i].regPoints[j].dateNextGosPov, this.search)
                            && foundInResult(searchResult, this.historyRawData[i].personAccountId)) {
                            searchResult.push(this.historyRawData[i]);
                        }
                    }
                }
                console.log(searchResult);
                return searchResult;
            },
            hideMessage() {
                $("#filter-message").hide();
            },
            showMessage(msg) {
                $("#filter-message").hide();
                $("#filter-message").html(msg);
                $("#filter-message").show();
            },
            check() {
                this.hideMessage();
                this.dateAlert = (this.DateTo.getTime() < this.DateFrom.getTime());
                if (this.dateAlert || (this.DateFrom == null) || (this.DateTo == null)) {
                    this.showMessage('Проверьте даты периода');
                    this.dateAlert = true;
                    return false;
                }
                var yearCnt = this.DateTo.getFullYear() - this.DateFrom.getFullYear();
                var monthCnt = (this.DateTo.getMonth() - this.DateFrom.getMonth() + 1) + (yearCnt * 12);

                if (monthCnt > 12) {
                    this.showMessage('Период не может быть более 12-ти месяцев');
                    this.dateAlert = true;
                    return false;
                }
                return true;
            },
            restoreBtn(btn) {
                setTimeout(function () {
                    btn.removeClass('is-overlay');
                    $('[data-catalog-view]').addClass('fadeIn').show();
                    $('[data-catalog-list]').addClass('fadeIn').show();
                    $('.js-form-btns-toggle').addClass('is-show');
                }, 256);

            },
            getData(event) {
                event.preventDefault();
                var btn = $(event.currentTarget);

                if (!this.check()) {
                    return;
                };
                var self = this;
                self.showMessage('Загрузка истории показаний');
                $(".block-wrap").hide();
                $('.js-form-btns-toggle').removeClass('is-show');

                self.historyRawData = [];

                var url =
                    ['/fl/equipments/gethistory?',
                        (this.accountId != '' ? 'account=' + this.accountId : ''),
                        (this.number != '' ? '&number=' + this.number : ''),
                        (this.state != '' ? '&state=' + this.state : ''),
                        '&dateFrom=' + yyyymmdd(this.DateFrom, '-'),
                        '&dateTo=' + yyyymmdd(this.DateTo, '-')
                    ].join('');

                btn.addClass('is-overlay');

                axios.get(url)
                    .then(function (response) {
                        console.log('получена история показаний ПУ');
                        self.hideMessage();
                        console.log(response);
                        if (response.data.accounts.length > 0) {
                            self.historyRawData = response.data.accounts;
                            self.historydata = self.historyRawData;
                            self.restoreBtn(btn);
                            $(".block-wrap").show();
                            return;
                        }
                    })
                    .catch(function (error) {
                        console.log('error ', error);
                        self.showMessage('Ошибка получения истории показаний. Повторите запрос.');
                        self.restoreBtn(btn);

                    });

            },
            onStartDateChanged: function (date) {
                this.DateFrom = date;
                if (!date) {
                    this.dateFrom = null;
                    return;
                }
                var mm = date.getMonth() + 1;
                var yyyy = date.getFullYear();
                var fromDate = "";
                if (mm < 10)
                    fromDate = fromDate + '0';
                fromDate = fromDate + mm + '.01.' + yyyy;
                this.dateFrom = fromDate;
                this.check();
            },
            onEndDateChanged: function (date) {
                var currDate = new window.Date();
                console.log("onEndDateChanged=", date, currDate);
                console.log("onEndDateChanged1=", date.getTime(), currDate.getTime());
                if (currDate < date) {
                    ///if (currDate.getTime() < date.getTime()) {
                    date = currDate;
                    console.log("onEndDateChanged2=", date, currDate);
                    this.maxDate = currDate;
                }

                this.DateTo = date;
                if (!date) {
                    this.dateTo = null;
                    return;
                }
                var mm = date.getMonth() + 1;
                var yyyy = date.getFullYear();
                var dd = new window.Date(yyyy, mm, 0);
                var toDate = "";
                if (mm < 10)
                    toDate = toDate + '0';
                toDate = toDate + mm + '.' + dd.getDate() + '.' + yyyy;
                this.dateTo = toDate;
                this.check();
            },
            refreshPpu: function () {
                var ctrl = $("#ppu");
                ctrl.empty();
                var o = $("<option value=''>Все приборы учета</option>");
                o.appendTo(ctrl);
                if (this.uaccount() != '') {
                    for (var i = 0; i < this.accounts.length; i++) {
                        if (this.accounts[i].PersonAccountId == this.accountId) {
                            for (var j = 0; j < this.accounts[i].RegPoints.length; j++) {
                                console.log(this.accounts[i].RegPoints[j]);
                                o = $("<option value='" + this.accounts[i].RegPoints[j].RegPointId + "'>" + this.accounts[i].RegPoints[j].SerialNum + "</option>");
                                o.appendTo(ctrl);
                            }
                        }
                    }
                }
                ctrl.selectpicker("refresh");
            }
        },
        mounted() {
            self = this;

            console.debug('ppu-history');
            this.minDate = new window.Date();
            this.maxDate = new window.Date();

            this.$nextTick(function () {
                if (self.accountId == "") {
                    $("#uaccount").selectpicker('refresh');
                    self.accountId = self.uaccount();
                }
                else {
                    self.refreshPpu();
                }
                self.setMinDate();
            });
        }
    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/ppu/ppu-history.vue